define("shared/helpers/moment-format", ["exports", "@ember/component/helper", "@ember/utils", "moment"], function (_exports, _helper, _utils, _moment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/utils",0,"moment"eaimeta@70e063a35619d71f
  /**
   * @module Helpers
   */
  /**
   * @class LaterHelpers
   * @extends Helpers
   */
  /**
   * Convert date time to specified format and timezone.
   *
   * @method moment-format
   * @param {String} dateTime Date time to be converted
   * @param {String} format Formatting or Internationalization for date time conversion
   * @param {String} timezone Timezone for date time conversion
   *
   * @return {String} Formatted date
   */
  class MomentFormat extends _helper.default {
    compute(_ref) {
      let [dateTime, format, timezone, secondaryFormat] = _ref;
      const newMoment = (0, _moment.default)(dateTime);
      if (!(0, _utils.isNone)(timezone)) {
        newMoment.tz(timezone);
      }
      if (secondaryFormat && (0, _moment.default)().isSame(newMoment, 'day')) {
        return newMoment.format(secondaryFormat);
      }
      return newMoment.format((0, _utils.isNone)(format) ? '' : format);
    }
  }
  _exports.default = MomentFormat;
});